import { Link, FieldProps, useRecordContext, ReferenceManyCount } from 'react-admin';

const DemoVideoLinkField = (props: FieldProps<any>) => {
    const record = useRecordContext<any>();
    if (!record) {
        return null;
    }
    return (
        <Link
            to={`/demo-videos?filter=${encodeURIComponent(
                JSON.stringify({ demoVideoCategoryId: record.id }),
            )}`}
        >
            Demo Videos
        </Link>
    );
};

DemoVideoLinkField.defaultProps = {
    label: 'Demo Videos',
};

export default DemoVideoLinkField;
